import { Table } from 'antd';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { t_machine } from 'types';

type DataTable = {
  machineData: t_machine[];
};

const TableInfo: FC<DataTable> = ({ machineData }) => {
  const { dataStoreMachineFields } = useSelector((state: RootState) => state.machineequipment);
  const optionMachineType = useMemo(() => {
    return (
      dataStoreMachineFields?.find(([_key, value]: [string, any]) => value.display_id === 'machine_type')[1].options ||
      []
    );
  }, [dataStoreMachineFields]);
  return (
    <div>
      <Table
        onRow={() => {
          return {
            // onClick: () => {
            //   moveTo();
            // },
          };
        }}
        columns={[
          {
            title: '',
            dataIndex: 'machine_id',
            key: 'machine_id',
            width: '6%',
            align: 'right',
            render(text: string, row: any, index: any) {
              return {
                props: {
                  style: { textAlign: 'right' },
                  className: 'standardFont',
                },
                children: <div>{index + 1}</div>,
              };
            },
          },
          {
            title: '機種',
            dataIndex: 'machine_type',
            key: 'machine_type',
            align: 'left',
            render(text: string) {
              const result = optionMachineType.find((f: any) => f.display_id === text);
              if (!result) {
                return '';
              }
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{result.value}</div>,
              };
            },
          },
          {
            title: '',
            dataIndex: 'machine_other',
            key: 'machine_other',
            align: 'left',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: 'シリアルナンバー',
            dataIndex: 'machine_serial_number',
            key: 'machine_serial_number',
            align: 'left',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '備考',
            dataIndex: 'machine_remark',
            key: 'machine_remark',
            align: 'left',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
        ]}
        dataSource={machineData}
        pagination={false}
      />
    </div>
  );
};

export default TableInfo;
